import to from "await-to-js";
import { BodyParam, TypeDetailInfo } from "@/apis/cart/cart.interface";
import { selectOtherProType } from "@/apis/cart/cart.api";
import { getUserUUIDFromCookie } from "@/utils/userUtils";
import { AttrUtils, AttrItemVo } from "./attrUtils";

export const loadOtherProTypeDetails = async (
  skuId: string,
  serviceItemIds?: string[],
): Promise<{ isSelect: boolean; typeDetailInfo?: TypeDetailInfo }> => {
  const requestData: BodyParam = {
    verticalTag: "cn_ybxt_b2c",
    cartuuid: getUserUUIDFromCookie(),
    extendParamMap: {
      stock: true,
    },
    skuId: skuId,
  };
  if (serviceItemIds && serviceItemIds.length > 0) {
    requestData["serviceItemIds"] = serviceItemIds;
    requestData["scene"] = 1;
  }
  const [err, result] = await to(selectOtherProType(requestData));
  if (err) {
    return { isSelect: false };
  } else {
    const newData = AttrUtils.initAttrListBySkuId(
      result?.selectedModule?.colorSizePartList || [],
      result?.commonModule?.["C-M#viewCommonItem&commonCore"]
        ?.skuId || "",
    );
    const isSelect = isSelectType(newData);
    return { isSelect, typeDetailInfo: result as TypeDetailInfo };
  }
};

// 是否可以选择其他商品
const isSelectType = (attrItemVo: AttrItemVo[]) => {
  if (!attrItemVo || attrItemVo.length === 0) {
    return false;
  }
  return attrItemVo.some((item) => item.itemList && item.itemList.length > 1);
};
